(function () {
  'use strict';

  angular
    .module('survey.surveyOutro', [])
    .controller('SurveyOutroCtrl', SurveyOutroCtrl);

  SurveyOutroCtrl.$inject = ['$scope', 'gettext'];

  function SurveyOutroCtrl ($scope, gettext) {
    //translate from DB
    gettext("Congratulations. You have finished the survey.");

    $scope.state = {
      trainerCompletionMessage: '',
      surveyTitlePrefix: ''
    };

    function setup() {
      if (!$scope.currentSlide || $scope.currentSlide.__type !== 'SurveyLastSlideInfo')
        return;

      $scope.state.trainerCompletionMessage = $scope.currentSlide.trainerCompletionMessage;
      $scope.state.surveyTitlePrefix = gettext('Survey Recap:');
    }

    setup();
  }
})();
